import React from 'react';
import { Competition } from '../models';
import { SimilarityType } from '../services/DataService';

interface CompetitionResultsProps {
  competitions: Competition[];
  onFindSimilar: (slug: string) => void;
  selectedSimilarityType: SimilarityType;
}

const CompetitionResults: React.FC<CompetitionResultsProps> = ({
  competitions,
  onFindSimilar,
  selectedSimilarityType
}) => {
  if (competitions.length === 0) {
    return <div className="no-results">検索結果がありません</div>;
  }

  return (
    <div className="results-container">
      <h2>コンペティション検索結果 ({competitions.length}件)</h2>
      <div className="results-list">
        {competitions.map((competition) => (
          <div key={competition.slug} className="result-card">
            <h3>{competition.title}</h3>
            <p className="subtitle">{competition.subtitle}</p>
            <div className="meta-info">
              <p><strong>締切日:</strong> {competition.deadlineDate}</p>
              <p><strong>参加者数:</strong> {competition.participantsCount.toLocaleString()}</p>
              <p><strong>データドメイン:</strong> {competition.dataDomain}</p>
            </div>
            <div className="tags">
              {competition.tags.map((tag) => (
                <span key={tag} className="tag">{tag}</span>
              ))}
            </div>
            <div className="actions">
              <button 
                onClick={() => onFindSimilar(competition.slug)}
                className="similar-button"
              >
                類似コンペを検索 ({getSimilarityTypeLabel(selectedSimilarityType)})
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// 類似性タイプのラベルを取得
const getSimilarityTypeLabel = (type: SimilarityType): string => {
  switch (type) {
    case SimilarityType.TITLE:
      return 'タイトル';
    case SimilarityType.TAGS:
      return 'タグ';
    case SimilarityType.DATA_DOMAIN:
      return 'データドメイン';
    case SimilarityType.DESCRIPTION:
      return '説明';
    case SimilarityType.ALL:
    default:
      return '総合';
  }
};

export default CompetitionResults;
